import { decodeJwtPayload } from "@/helpers/utils.helper.ts";
import { ApiErrorException, ApiErrors, ApiValidationError } from "@/types/api.types.ts";
import { InviteFlow, InviteTokenPayload } from "@/types/security.types.ts";

const INVITE_CODE_TOKEN_TYPES = new Set(["invite_link_work", "invite_link_personal"]);

export const getInviteFlow = (token?: string): InviteFlow => {
  if (!token) return InviteFlow.loading;

  const payload = decodeJwtPayload<InviteTokenPayload>(token);

  return payload?.type && INVITE_CODE_TOKEN_TYPES.has(payload.type)
    ? InviteFlow.code
    : InviteFlow.password;
};

export const hasValidationError = (error: unknown, code: string): error is ApiValidationError =>
  !!error &&
  typeof error === "object" &&
  "status" in error &&
  error.status === ApiErrors.validationError &&
  "validationErrors" in error &&
  Array.isArray(error.validationErrors) &&
  error.validationErrors.some((validationError) => validationError.code === code);

export const getApiError = (error: unknown) =>
  error instanceof ApiErrorException ? error.apiError : undefined;
